import React from 'react';
import { Header, Footer } from '../Common';
import MenuItemShop from '../../Common/MenuItemShop/MenuItemShop';

/** CLS-SE fallback listing for a header menu item (/clothing/cls-se/shop/:menuItemKey). */
const CLSSEMenuItemShop = () => (
  <MenuItemShop
    brandSlug="clsse"
    feSlug="cls-se"
    dataBrand="CLS"
    HeaderComponent={Header}
    FooterComponent={Footer}
    packageDescription="Paketlösning"
    loadingText="Laddar produkter…"
    emptyTitle="Inga produkter just nu"
    emptyText="Kollektionen kanske uppdateras just nu. Har du frågor hjälper vi gärna till."
    contactLabel="Kontakta oss"
    faqLabel="Se FAQ"
  />
);

export default CLSSEMenuItemShop;
